export default __webpack_public_path__ + "static/media/Axe of Red Ruin.20f7a68c.jpg";